/**
 * search-precision.js  —  Sklep JCB Interhandler
 *
 * Cel: gdy użytkownik szuka kodu części / SKU / zamiennika (np. 700/50114,
 * 700/36800, 320-07382), wymuszamy DOKŁADNE dopasowanie zamiast rozmytego.
 *
 * Jak: kody są opakowywane w cudzysłów ("700/50114") -> Shopify robi wtedy
 * exact phrase search i wyłącza typo-tolerance/prefix, dzięki czemu nie
 * wyskakują "podobne" 700/... . Działa na polu SKU oraz na TAGACH (tam
 * trafiają zamienniki). Zwykłe frazy wielowyrazowe ("filtr oleju") NIE są
 * ruszane — działają jak dotąd.
 *
 * Zakres: formularz w nagłówku, formularz na stronie wyników oraz live
 * predictive-search (przez lekki wrapper na fetch ograniczony WYŁĄCZNIE do
 * endpointu /search/suggest).
 */
(function () {
  'use strict';

  // --- Heurystyka "to jest kod części" --------------------------------------
  // Reguła: jeden token (bez spacji), zawiera cyfrę, ORAZ ma "/" lub "-"
  // albo jest alfanumeryczny o długości >= 5. Łatwa do dostrojenia w razie
  // potrzeby (np. dodanie kropki, podkreślnika itp.).
  function looksLikeCode(q) {
    if (!q) return false;
    if (/\s/.test(q)) return false;   // wiele słów -> normalne wyszukiwanie
    if (/^".*"$/.test(q)) return false; // już zacytowane przez usera
    if (!/\d/.test(q)) return false;  // kod musi mieć cyfrę
    return /[\/\-]/.test(q) || q.length >= 5;
  }

  function toPhrase(q) {
    return '"' + q.trim() + '"';
  }

  // --- 1) Formularze wyszukiwania (submit) ----------------------------------
  // Przechwytujemy w fazie capture, zanim zadziała logika theme'u.
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || form.getAttribute('role') !== 'search') return;

      var input = form.querySelector('input[name="q"]');
      if (!input) return;

      var raw = (input.value || '').trim();
      if (!looksLikeCode(raw)) return;

      // Exact phrase + wyłączenie prefiksu na ostatnim członie.
      input.value = toPhrase(raw);

      var prefix = form.querySelector('input[name="options[prefix]"]');
      if (prefix) prefix.value = 'none';
    },
    true // capture
  );

  // --- 2) Predictive search (live dropdown) ---------------------------------
  // Wrapper na fetch, działa TYLKO dla endpointu predictive search.
  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (resource, init) {
      try {
        if (typeof resource === 'string' && resource.indexOf('/search/suggest') !== -1) {
          var u = new URL(resource, window.location.origin);
          var q = u.searchParams.get('q');
          if (q && looksLikeCode(q.trim())) {
            u.searchParams.set('q', toPhrase(q.trim()));
            resource = u.pathname + u.search;
          }
        }
      } catch (e) {
        /* w razie czego: nie blokujemy oryginalnego zapytania */
      }
      return nativeFetch.call(this, resource, init);
    };
  }
})();
